module.exports = __webpack_public_path__ + "img/vertical_7_4_3.13c0b590.png";